import type { AnyRouter } from "@tanstack/react-router";
import { findNavByPath } from "./navigation";

declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[];
  }
}

const BASE = import.meta.env.BASE_URL.replace(/\/$/, "");

// Router locations may drop the basepath; GA reports the public URL.
export function toPublicPath(pathname: string): string {
  return pathname.startsWith(BASE) ? pathname : `${BASE}${pathname}`;
}

export function pushEvent(
  event: string,
  params: Record<string, unknown> = {},
): void {
  const dataLayer = (window.dataLayer ??= []);
  dataLayer.push({ event, ...params });
}

export function pushPageView(pathname: string, searchStr = ""): void {
  const path = toPublicPath(pathname);
  pushEvent("page_view", {
    page_path: `${path}${searchStr}`,
    page_location: `${window.location.origin}${path}${searchStr}`,
    page_title: findNavByPath(path)?.label ?? document.title,
  });
}

export function trackPageViews(router: AnyRouter): () => void {
  return router.subscribe("onResolved", (event) => {
    if (!event.pathChanged && !event.hrefChanged) return;
    pushPageView(event.toLocation.pathname, event.toLocation.searchStr);
  });
}
